document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ Kaching2.js loaded");

  const VAT_MULTIPLIER = 1.25;
  const PRICE_SELECTORS = [
    ".kaching-bundles__bar-price",
    ".kaching-bundles__bundle-products__price"
  ];

  function parsePrice(text) {
    // Fjern alt undtagen cifre, komma og punktum
    let cleaned = text.replace(/[^\d.,]/g, "");

    // Hvis både punktum og komma findes, antag punktum = tusind, komma = decimal
    if (cleaned.includes(".") && cleaned.includes(",")) {
      cleaned = cleaned.replace(/\./g, "").replace(",", ".");
    } else {
      // Hvis kun komma: brug komma som decimal
      if (cleaned.includes(",") && !cleaned.includes(".")) {
        cleaned = cleaned.replace(",", ".");
      }
      // Hvis kun punktum: lad det være som decimal
    }

    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function formatDKK(value) {
    // 2 decimals, komma som decimal
    return value
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // tusindtalsprik
  }

  function getPriceElements(root = document) {
    const list = [];
    PRICE_SELECTORS.forEach(sel => {
      root.querySelectorAll(sel).forEach(el => list.push(el));
    });

    // Undersøg shadow roots i kaching-bundle (hvis appen bruger dem)
    root.querySelectorAll("kaching-bundle").forEach(bundle => {
      if (bundle.shadowRoot) {
        PRICE_SELECTORS.forEach(sel => {
          bundle.shadowRoot.querySelectorAll(sel).forEach(el => list.push(el));
        });
      }
    });

    return list;
  }

  function updateKachingPrices(root = document) {
    let count = 0;

    getPriceElements(root).forEach((element) => {
      const originalText = element.innerText.trim();

      if (element.hasAttribute("data-vat-updated")) return;

      const priceValue = parsePrice(originalText);
      if (priceValue && priceValue > 0) {
        const newPrice = priceValue * VAT_MULTIPLIER;
        element.innerText = `${formatDKK(newPrice)} kr`;
        element.setAttribute("data-vat-updated", "true");
        count++;
      }
    });

    if (count > 0) {
      console.log(`✅ VAT updated on ${count} price element(s).`);
    }
    return count;
  }

  // 1) Kør straks (hvis elementer allerede er til stede)
  updateKachingPrices();

  // 2) Poll kortvarigt efter load (app-lazyload fallback)
  let attempts = 0;
  const maxAttempts = 40; // ~10 sek ved 250ms
  const poll = setInterval(() => {
    attempts++;
    const updated = updateKachingPrices();
    if (updated > 0 || attempts >= maxAttempts) {
      clearInterval(poll);
    }
  }, 250);

  // 3) Global MutationObserver – fanger ALT der tilføjes (også kaching-bundle senere)
  const globalObserver = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    for (const m of mutations) {
      if (m.type === "childList" && (m.addedNodes?.length || m.removedNodes?.length)) {
        shouldUpdate = true;
        break;
      }
      if (m.type === "attributes") {
        shouldUpdate = true;
        break;
      }
    }
    if (shouldUpdate) updateKachingPrices();
  });

  globalObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: false
  });

  // 4) Opdater når bruger ændrer varianter/valg
  document.body.addEventListener("change", function (event) {
    if (event.target.matches("select, input[type='radio'], input[type='checkbox']")) {
      updateKachingPrices();
    }
  });

  // 5) Sikkerhed: kør også efter window.load
  window.addEventListener("load", () => updateKachingPrices());
});
